export enum FileStatus {
    Init = 'INIT',
    Imported = 'IMPORTED',
    Calculated = 'CALCULATED',
    Optimized = 'OPTIMIZED',
    Exported = 'EXPORTED',
    ResultSent = 'RESULT_SENT',
    Done = 'DONE',
    Archived = 'ARCHIVED',
    Deleted = 'DELETED',
}

export function getLocalizedFileStatus(): Record<FileStatus, string> {
    return {
        'INIT': $localize`:@@status.init:Klaar voor uitvoeren`,
        'IMPORTED': $localize`:@@dossierStatus.imported:Geïmporteerd`,
        'CALCULATED': $localize`:@@dossierStatus.calculated:Berekend`,
        'OPTIMIZED': $localize`:@@dossierStatus.optimized:Geoptimaliseerd`,
        'EXPORTED': $localize`:@@dossierStatus.exported:Geëxporteerd`,
        'RESULT_SENT': $localize`:@@dossierStatus.resultSent:Resultaat verzonden`,
        'DONE': $localize`:@@dossierStatus.done:Ingediend`,
        'ARCHIVED': $localize`:@@dossierStatus.archived:Gearchiveerd`,
        'DELETED': $localize`:@@dossierStatus.deleted:Verwijderd`,
    };
}
